// Allow Hot Module Replacement (HMR) for JS files
// For more details see https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept();
}

import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import './stage.scss';

const removeVideoControlsImmediately = () => {
  document.querySelectorAll('.stage__background video').forEach((video) => {
    video.removeAttribute('controls');
  });
};

const initStageCarousel = () => {
  const sliders = document.querySelectorAll('.stage-slider');

  sliders.forEach((slider) => {
    if (slider.dataset.initialized === 'true') {
      return;
    }

    try {
      const splide = new Splide(slider, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: 0,
        drag: true,
        keyboard: 'global',
        arrows: true,
        pagination: false,
        speed: 400,
        easing: 'ease-in-out',
        trimSpace: false,
      });

      splide.mount();
      slider.dataset.initialized = 'true';
    } catch (error) {
      delete slider.dataset.initialized;
      console.error('StageSlider: Failed to initialize Splide', error);
    }
  });
};

const initStageVideoControls = () => {
  document.querySelectorAll('.stage__background').forEach((background) => {
    const video = background.querySelector('video');
    const stage = background.closest('.stage');
    const btn = stage?.querySelector('.stage__video-control');

    if (!video || !btn || !stage) return;

    video.removeAttribute('controls');

    const updateState = (playing) => {
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      btn.setAttribute('aria-label', playing ? 'Stop' : 'Play');
    };

    updateState(!video.paused);

    const setStoppedByUser = (stopped) => {
      stage.classList.toggle('video-stopped-by-user', stopped);
    };

    video.addEventListener('play', () => updateState(true));
    video.addEventListener('pause', () => updateState(false));

    btn.addEventListener('click', () => {
      if (video.paused) {
        setStoppedByUser(false);
        video.play();
      } else {
        setStoppedByUser(true);
        video.pause();
      }
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !stage.classList.contains('video-stopped-by-user')) {
            video.play();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(background);
  });
};

const initStage = () => {
  initStageCarousel();
  initStageVideoControls();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStage, { once: true });
} else {
  initStage();
}

removeVideoControlsImmediately();
